const SENDING_ZONE = 'sending';

const syncLineToZone = (line) => {
    const wrapper = line.querySelector('[data-stepped-integer]');

    if (!wrapper) {
        return;
    }

    const sending = line.closest('[data-submission-zone]')?.dataset.submissionZone === SENDING_ZONE;

    wrapper.classList.toggle('disabled', !sending);

    const input = wrapper.querySelector('input');

    if (input) {
        input.disabled = !sending;
    }
};

const refreshSummary = (panel) => {
    const summary = panel.querySelector('[data-submission-summary]');

    if (!summary) {
        return;
    }

    const sending = panel.querySelectorAll(
        `[data-submission-zone="${SENDING_ZONE}"] [data-submission-line]`,
    ).length;

    summary.textContent = summary.dataset.countTemplate
        .replace('%d', sending)
        .replace('%d', summary.dataset.submissionTotal)
        .replace('%s', summary.dataset.submissionIntegration)
    ;
};

export const handleSubmissionValidationHalted = (event) => {
    const form = event.target.closest?.('.submission-preview');

    if (!form) {
        return;
    }

    const invalid = form.querySelectorAll('input:invalid');

    invalid.forEach((input) => input.classList.add('is-invalid'));

    invalid[0]?.focus();
};

export const clearSubmissionValidationState = (event) => {
    if (!event.target.closest?.('.submission-preview')) {
        return;
    }

    event.target.classList?.remove('is-invalid');
};

document.addEventListener('sortabledrop', (event) => {
    const line = event.target.closest('[data-submission-line]');

    if (!line) {
        return;
    }

    syncLineToZone(line);

    refreshSummary(line.closest('.submission-preview'));
});
